import { createDefaultTheme } from '../../../themes';
import { Article } from '../../../types/Article';
import { BreadcrumbProps } from '../../../types/Breadcrumb';
import { SearchWordListAttribute } from '../../../types/SearchWordListAttribute';
import { SideMenuType } from '../../../types/SideMenuType';
import { TagAttribute } from '../../../types/TagAttribute';
import { Footer } from '../../Footer';
import { Header } from '../../Header';
import { MainSearch } from '../../MainVisual/MainSeach';
import { Breadcrumb } from '../../Navigation/Breadcrumb';
import { GrayBorder } from '../../Parts/GrayBorder';
import { SideMenu } from '../../SideMenu';

import styles from './LayoutTwoColumn.module.scss';

import type { AuthorizationRequest } from '../../../types/AuthorizationRequest';
import type { LoggedInUser } from '../../../types/LoggedInUser';
import type { PageHeader } from '../../../types/PageHeader';
import type { AppEnv } from '@/packages/nurse-senka-frontend-sdk';
import type { FC, ReactNode } from 'react';

export type LayoutTwoColumnProps = {
  pageHeader: PageHeader;
  sideMenuType: SideMenuType;
  appEnv: AppEnv;
  isLoggedIn: boolean;
  loggedInUser: LoggedInUser;
  breadcrumbElements: BreadcrumbProps[];
  authorizationRequest?: AuthorizationRequest;
  children?: ReactNode;
  knowledgeRankingArticles?: Article[];
  squareRankingArticles?: Article[];
  relatedTags?: TagAttribute[];
  singleLayout?: boolean;
  abcSearchAttribute?: SearchWordListAttribute[];
};

export const LayoutTwoColumn: FC<LayoutTwoColumnProps> = ({
  pageHeader,
  sideMenuType,
  appEnv,
  isLoggedIn,
  loggedInUser,
  authorizationRequest,
  breadcrumbElements,
  children,
  knowledgeRankingArticles,
  squareRankingArticles,
  relatedTags,
  singleLayout,
  abcSearchAttribute,
}) => {
  const defaultTheme = createDefaultTheme();

  return (
    <div className={styles.wrap}>
      <Header
        appEnv={appEnv}
        authorizationRequest={authorizationRequest}
        loggedInUser={loggedInUser}
        theme={defaultTheme}
      />
      <Breadcrumb breadcrumbElements={breadcrumbElements} />

      {singleLayout ? (
        <GrayBorder />
      ) : (
        <MainSearch
          pageHeader={pageHeader}
          isLoggedIn={isLoggedIn}
          appEnv={appEnv}
          loggedInUser={loggedInUser}
        />
      )}

      <div className={styles['wrap-body']}>
        <div className={styles['wrap-body-contents']}>{children}</div>
        <div className={styles['wrap-body-side-area']}>
          <SideMenu
            sideMenuType={sideMenuType}
            abcSearchAttribute={abcSearchAttribute}
            appEnv={appEnv}
            knowledgeRankingArticles={knowledgeRankingArticles}
            squareRankingArticles={squareRankingArticles}
            relatedTags={relatedTags}
          />
        </div>
      </div>

      <Footer
        appEnv={appEnv}
        isLoggedIn={isLoggedIn}
        authorizationRequest={authorizationRequest}
      />
    </div>
  );
};
